/**
 * Format a price value to 2 decimal places
 * @param {string|number} price - Price value to format
 * @returns {string} Formatted price string with 2 decimal places
 */
export const formatPrice = (price) => {
    const num = parseFloat(price);
    if (isNaN(num)) {
        return '0.00';
    }
    return num.toFixed(2);
};

/**
 * Format a price with currency suffix
 * @param {string|number} price - Price value to format
 * @param {string} currency - Currency suffix (default: 'դրամ')
 * @returns {string} Formatted price with currency
 */
export const formatPriceWithCurrency = (price, currency = 'դրամ') => {
    return `${formatPrice(price)} ${currency}`;
};

